import styled from 'styled-components';
import { Typography } from '@optimus-web/core';

export const FloatLeftLabel = styled(Typography).attrs({ textStyle: 'bodyMediumStrong' })`
    float: left;
`;
